import Joi from "joi";
import { requiredString } from "../../../../utils/schema";

export const createUserFormSchema = Joi.object({
  email: requiredString(
    "Email",
    Joi.string().email({ tlds: false }).min(1).max(200)
  ),
});
